export const hasHandicap = value => typeof value === 'number' && Number.isFinite(value);
export const handicapLabel = value => hasHandicap(value) ? value.toFixed(1) : 'Not established';
export const isSynthetic = player => player?.auth_provider === 'synthetic' || ['is_bot', 'is_ai', 'is_ai_generated', 'is_ambassador', 'is_pro_mentor'].some(k => player?.[k] === true);

// An empty optional field is explicitly unset, never parsed as numeric zero.
export const parseOptionalHandicap = value => {
  if (value == null || (typeof value === 'string' && value.trim() === '')) return null;
  if (typeof value === 'boolean' || !['string','number'].includes(typeof value)) throw new Error('Enter a finite handicap');
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) throw new Error('Enter a finite handicap');
  return parsed;
};

export const eventHandicap = player => {
  if (player?.net_eligible === false || !hasHandicap(player?.handicap)) return null;
  if (player.handicap_source === 'manual') return player.handicap;
  return isSynthetic(player) || player.handicap_verified === false ? null : player.handicap;
};
export const handicapBaseline = players => {
  const values = players.map(eventHandicap).filter(hasHandicap);
  return values.length ? Math.min(...values) : null;
};
export const handicapStrokes = (handicap, baseline) => hasHandicap(handicap) && hasHandicap(baseline) ? Math.max(0, Math.trunc(handicap - baseline)) : 0;
export const netScore = (gross, handicap, baseline) => hasHandicap(handicap) ? gross - handicapStrokes(handicap, baseline) : null;
export const verifiedIndex = player => player?.handicap_visibility !== 'hidden' && !isSynthetic(player) && player?.handicap_verified !== false && hasHandicap(player?.handicap);
export const leaderboardHandicapLabel = player => player?.handicap_visibility === 'hidden' ? 'Private' : verifiedIndex(player) ? player.handicap.toFixed(1) : 'Not established';
export const handicapRanking = golfers => {
  const ranked = golfers.filter(verifiedIndex).sort((a,b) => a.handicap-b.handicap).map((p,i) => ({...p, handicap_rank:i+1}));
  const unranked = golfers.filter(p => !verifiedIndex(p)).map(p => ({...p, handicap_rank:null}));
  return [...ranked,...unranked];
};

// undefined = not fetched; null = fetched and NOT established.
export const latestHandicapValue = (latest, previous) => latest === undefined ? previous : latest;